// src/SuspendResumeCredentialModal.js
import React from "react";
import "./SuspendResumeCredentialModal.css";

const SuspendResumeCredentialModal = ({
  isOpen,
  onClose,
  onConfirm,
  action, // "suspend" or "resume"
  credentialId,
  patronName,
  badgeId,
  deviceType,
  deviceCount,
  isProcessing,
}) => {
  if (!isOpen) return null;

  const isSuspend = action === "suspend";
  const title = isSuspend ? "⏸️ Suspend Credential" : "▶️ Resume Credential";
  const actionText = isSuspend ? "suspend" : "resume";
  // const actionTextCaps = isSuspend ? "Suspend" : "Resume";
  const emoji = isSuspend ? "⏸️" : "▶️";
  const processingText = isSuspend ? "Suspending..." : "Resuming...";
  const buttonText = isSuspend ? "Suspend Credential" : "Resume Credential";

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <>
      <div className="suspend-resume-modal-overlay" onClick={onClose} />
      <div className="suspend-resume-modal">
        <h2>{title}</h2>
        <div className="suspend-resume-modal-content">
          <p className="suspend-resume-warning">
            Are you sure you want to {actionText} this credential?
          </p>

          <div className="suspend-resume-details">
            {patronName && (
              <p>
                <strong>User:</strong> {patronName}
              </p>
            )}
            {badgeId && (
              <p>
                <strong>Badge ID:</strong> {badgeId}
              </p>
            )}
            {deviceType && (
              <p>
                <strong>Device Type:</strong> {deviceType.replace("_", " ")}
              </p>
            )}
            <p className="suspend-resume-id">
              <strong>Credential ID:</strong> {credentialId}
            </p>
            {deviceCount > 0 && (
              <p>
                <strong>Active on:</strong> {deviceCount} device
                {deviceCount !== 1 ? "s" : ""}
              </p>
            )}
          </div>

          <div className="suspend-resume-notice">
            {isSuspend ? (
              <>
                <p>
                  {emoji} This will suspend the credential in Apple/Google
                  Wallet.
                </p>
                <p>
                  The credential will be disabled on all {deviceCount} device
                  {deviceCount !== 1 ? "s" : ""}.
                </p>
                <p>You can resume it later to restore access.</p>
              </>
            ) : (
              <>
                <p>
                  {emoji} This will resume the credential in Apple/Google
                  Wallet.
                </p>
                <p>
                  The credential will be re-enabled on all {deviceCount} device
                  {deviceCount !== 1 ? "s" : ""}.
                </p>
                <p>Access will be restored immediately.</p>
              </>
            )}
          </div>
        </div>

        <div className="suspend-resume-modal-actions">
          <button
            className="suspend-resume-cancel-btn"
            onClick={onClose}
            disabled={isProcessing}
          >
            Cancel
          </button>
          <button
            className={`suspend-resume-confirm-btn ${
              isSuspend ? "suspend" : "resume"
            }`}
            onClick={handleConfirm}
            disabled={isProcessing}
          >
            {isProcessing ? processingText : buttonText}
          </button>
        </div>
      </div>
    </>
  );
};

export default SuspendResumeCredentialModal;
